import React from 'react';
import '../styles/Footer.css';
import logo from '../assets/Logo.png';
import { Image } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <Image src={logo} alt="TalkShow" height="35" />
          <p className="footer-tagline">
            Your gateway to exploring the world of ideas <br />
            through engaging talk shows and AI-powered <br />
            discussions.
          </p>
        </div>

        <ul className="footer-links">
          <li className="header">Quick Links</li>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/news">Talk Shows</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/chat-bot">AI Assistant</Link></li>
        </ul>
      </div>

      <p className="footer-copy">© 2025 DebateMindAI. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
